import { JSONCompatible, hasOwnProperty } from '@direct-frontend/stdlib';

/**
 * Сообщение об ошибке с простой интерполяцией данными из additional.
 *
 * @example
 *   message: 'Failed to GET /campaigns/{id}'
 *   additional: { id: '123' }
 *   result: 'Failed to GET /campaigns/123'
 *
 * @param message Оригинальное сообщение
 * @param data Данные для интерполяции
 * @returns Отформатированное сообщение
 */
export function formatMessage<Data extends JSONCompatible<Data>>(message: string, data: Data | undefined) {
    if (!data) {
        return message;
    }

    // заменяем из сообщения все подстроки вида `{something}`
    // на значение `something` из data
    return message.replace(/{([^{}]+)}/g, (propWithBrackets): string => {
        const prop = propWithBrackets.slice(1, -1); // {id} => id

        if (hasOwnProperty(data, prop)) {
            return String(data[prop]);
        }

        return propWithBrackets;
    });
}
